import React, { type PropsWithChildren, Children, cloneElement, isValidElement } from "react";
import { twMerge } from "tailwind-merge";

import type { TabProps } from "../Tab";

export interface TabListProps extends PropsWithChildren {
  value?: string | number;
  scrollable?: boolean;
  onChange?: (value: string | number) => void;
  orientation?: "horizontal" | "vertical";
  indicatorPosition?: "top" | "bottom" | "left" | "right";
  className?: string;
}

export function SupTabList({ value, orientation = "horizontal", indicatorPosition, onChange, children, className }: TabListProps) {
  const createHandleClick = (value: string | number) => () => {
    onChange?.(value);
  };

  return (
    <div className={twMerge("sup-tab-list flex", orientation === "vertical" && "flex-col", className)}>
      {Children.map(children, (child, index) => {
        if (!isValidElement<TabProps>(child)) return null;
        const tabValue = child.props.value ?? index;

        return cloneElement(child, { active: value === tabValue, onClick: createHandleClick(tabValue), orientation, indicatorPosition });
      })}
    </div>
  );
}
